// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

const textStyle = css`
  font-family: ${fontCondensed};
  font-size: 12px;
  text-transform: uppercase;
  color: ${buildColor("blue", "D1")};
  letter-spacing: 1px;
`;

export const InformationContainer = styled.div`
  background-color: ${buildColor("grey", "100")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-top: 1px solid ${buildColor("grey", "300")};
  border-bottom: 1px solid ${buildColor("grey", "300")};
`;

export const HorseDetails = styled.span`
  ${textStyle}
`;

export const SortType = styled.div`
  ${textStyle};
  display: flex;
  align-items: center;
`;
